import axios from '@utils/axios';

export async function getShareVideo(params: {
  predict_id: string;
}): Promise<GenVideoItem> {
  const result = await axios.get('/api/video/share', { params });
  return result?.data?.item;
}

export async function getVideoSearch(params: {
  query: string;
  page_size: number;
  page: number;
}): Promise<VideoSearch> {
  const result = await axios.get('/api/video/search', { params });
  return result?.data || {};
}

export async function deleteVideo(params: {
  predict_ids: string;
}): Promise<string> {
  const result = await axios.delete('/api/video/delete', { params });

  return result?.message;
}

// platform 空 为全部
// discord = 0
// wechat = 1
// story_web = 2
// dancing_app = 3
// action_lib = 4
// actor_motion = 5
// avatar = 7
export async function getVideoList(params: {
  platform?: number;
  page_num?: number;
  page_size?: number;
  is_today?: number | string;
}): Promise<{
  video_list: GenVideoItem[];
  total: number;
}> {
  const result = await axios.get('/api/video/list', {
    params,
  });
  return result?.data;
}

export async function getVideoTemplateList(params: {
  page_num: number;
  page_size: number;
}): Promise<{
  template_list: VideoTemplateItem[];
}> {
  const result = await axios.get('/api/template/list', {
    params,
  });
  return result?.data;
}

export async function getVideoTemplateItem(params: {
  session_id: string;
  style?: string;
}): Promise<VideoTemplateItem> {
  const result = await axios.get('/api/template', {
    params,
  });
  return result?.data?.item;
}

export async function getVideoSessionList(params: {
  session_id: string;
  page_num: number;
  page_size: number;
}): Promise<GenVideoItem[]> {
  const result = await axios.get('/api/video/session', {
    params,
  });
  return result?.data?.video_list;
}

export async function getDownloadVideo(params: {
  item_id: string;
}): Promise<Video> {
  const result = await axios.get('/api/video/download', {
    params,
  });
  return result?.data?.video;
}

export async function getVideoPodcast(params: {
  page_num: number;
  page_size: number;
}): Promise<PodcastVideo[]> {
  const result = await axios.get('/api/video/podcast', {
    params,
  });
  return result?.data?.list;
}
